<template>
    <div>
      <Head title="Actualizar Descuento" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-sky-400 hover:text-sky-600" href="/products/discounts">Descuentos</Link>
        <span class="text-sky-400 font-medium">/</span> Editar
      </h1>
      
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
            <select-input v-model="form.producto" :error="form.errors.producto" class="pb-8 pr-6 w-full lg:w-1/2" label="Producto">
              <option v-for="product in allProducts" :key="product.id" :value="product.id">{{ product.producto }}</option>
            </select-input>

            <div class="pb-8 pr-6 mt-6 w-full " >
              <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">Periodo</h3>
              <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input id="checkbox-period-dates" type="radio" value="Fechas" v-model="form.period" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="checkbox-period-dates" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Fechas</label>
                      </div>
                  </li>
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input id="checkbox-period-extend" type="radio" value="Indefinido" v-model="form.period" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="checkbox-period-extend" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Indefinido</label>
                      </div>
                  </li>
              </ul>
            </div>
            <div v-if="form.period=='Fechas'" class="pb-1 pr-6 w-full " >
              <VueDatePicker v-model="form.date_range"  :enable-time-picker="false" :min-date="new Date()" range
                        model-type='dd.MM.yyyy' :clearable="true" no-today placeholder="Seleccionar periodo de descuento"
                        input-class-name="dp-custom-input"  teleport-center :error="form.errors.date_range" />
                        <span v-if="form.errors.date_range" class="text-red-600 text-sm">{{ form.errors.date_range }}</span>
            </div> 
            <div v-if="form.period=='Indefinido'" class="pb-1 pr-6 w-full " >
              <VueDatePicker v-model="form.date_init"  :enable-time-picker="false" :min-date="new Date()" 
                        model-type='dd.MM.yyyy' :clearable="true" no-today placeholder="Selecciona una fecha de inicio"
                        input-class-name="dp-custom-input"  teleport-center :error="form.errors.date_range" />
                        <span v-if="form.errors.date_range" class="text-red-600 text-sm">{{ form.errors.date_range }}</span>
            </div>
            
            <div class="pb-8 pr-6 mt-6 w-full " >
              <h3 class="mb-4 font-semibold text-gray-900 dark:text-white">Tipo</h3>
              <ul class="items-center w-full text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input id="vue-checkbox-list" type="radio" value="Caja" v-model="form.type" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="vue-checkbox-list" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Caja</label>
                      </div>
                  </li>
                  <li class="w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600">
                      <div class="flex items-center ps-3">
                          <input id="react-checkbox-list" type="radio" value="Efectivo" v-model="form.type" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500">
                          <label for="react-checkbox-list" class="w-full py-3 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Efectivo</label>
                      </div>
                  </li>
              </ul>
            </div>
  
            <text-input v-if="form.type=='Caja'" v-model="form.condition" :error="form.errors.condition" class="pb-8 pr-6 w-full lg:w-1/2" label="Condición por cajas" type="number" />
            <text-input v-if="form.type=='Caja'" v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-1/2" label="Descuento en cajas" type="number"  step="0.01" />
            <text-input v-if="form.type=='Efectivo'" v-model="form.condition" :error="form.errors.condition" class="pb-8 pr-6 w-full lg:w-1/2" label="Condición por cajas" type="number" />
            <text-input v-if="form.type=='Efectivo'" v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-1/2" label="Descuento en efectivo" type="number"  step="0.01" />
          </div>
        
  
          
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button :loading="form.processing" class="btn-sky" type="submit">Actualizar Descuento</loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'
  import LoadingButton from '@/Shared/LoadingButton.vue'
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css'
      
  export default {
    components: {
      Head,
      Link,
      LoadingButton,
      TextInput,
      SelectInput,
      VueDatePicker
    },
    layout: Layout,
    props: {
      allProducts: Array,
      discount: Object
    },
    remember: 'form',
    data() {
      return {
        form: this.$inertia.form({
          name:this.discount.name,
          producto: this.discount.id_product,
          date_init: this.discount.end_date ? null : this.discount.init_date,
          date_range: this.discount.end_date ? [this.discount.init_date, this.discount.end_date] : [],
          type:this.discount.type,
          condition:this.discount.condition,
          discount:this.discount.discount,
          period:this.discount.period,
         
        }),
         //picked:''
        //customPosition : ({ top: 0, left: 0 })
  
      }
    },
    methods: {
      update() {
        this.form.put(`/products/discounts/${this.discount.id}`)
        //console.log(this.form)
      },
      customPosition() {
              return { top: 0, left: 0 };
          }
    },
  }
  </script>
  